module.exports = __webpack_public_path__ + "static/PAINT-Colour-Cross-Ref-edf33a150ad2f62897b4bee682fa870e.pdf";